import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 登录接口
export const login = (params) => { return loginreq("post", "/api/user/login.do", params) };

// 退出
export const loginout = () => { return req("put", "/api/user/logout.do") };
// 用户管理-获取用户列表
export const userList = (params) => { return req("get", "/api/user/findAll.do/"+params.page+"/"+params.limit, params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js